import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '../../components/Layout/Layout';
import { RootState } from '../../store';
import { UserState } from '../../store/reducers/userReducer';
import DashboardService from '../../services/DashboardService/DashboardService';
import './index.css';
import LcLoading from '../../components/Generic/LcLoading';
import { PrefState } from '../../store/reducers/prefReducer';

const SLAReport: React.FC = (props) => {
    const user = useSelector<RootState, UserState>(state => state.user);
    const pref = useSelector<RootState, PrefState>(state => state.pref);
    const dispatch = useDispatch();
    const dashboardService = new DashboardService(props);

    const [report, setReport] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [principalTitle, setPrincipalTitle] = useState<string>('');
    const [topTitle, setTopTitle] = useState<any[]>([]);
    const [values, setValues] = useState<any[]>([]);
    const [fieldReport, setFieldReport] = useState<any[]>([]);

    useEffect(() => {
        const getListRepost = async () => {
            try {
                let responseList = await dashboardService.getReportList(Number(user.id));

                const fieldReport_ = responseList.data.map(i => {
                    return {
                        label: i.nome,
                        text: i.nome,
                        default: ((pref.dataLocal?.SlaReportSolicitation) ? pref.dataLocal?.SlaReportSolicitation : 0) === i.id,
                        field: [{ name: i.nome, value: i.id }]
                    }
                });

                setFieldReport(fieldReport_);
            }
            catch (error) {
                console.debug(error);
            }
        }

        user.id && getListRepost();
    }, [user.id])

    const getReportInfo = async () => {
        setLoading(true);

        let arrayTopTitle: Array<string> = [];
        let arrayValues: Array<any> = [];

        try {
            let responseInfo = await dashboardService.getReportInfo(report - 30000, user.id as number);

            setPrincipalTitle(responseInfo.data[0].titulo);

            responseInfo.data.forEach((title: any) => {
                if (title.tituloCard !== null) {
                    arrayTopTitle.push(title.tituloCard);

                    let objetoCard = {
                        grupo: title.titulo,
                        value: title.value,
                        frente: title.tituloFrente,
                        fundo: title.tituloFundo
                    }

                    arrayValues.push(objetoCard);
                }
            });

            setTopTitle(arrayTopTitle.filter((este, i) => arrayTopTitle.indexOf(este) === i));

            let agrupado = groupByValuesList(arrayValues, responseInfo.data);
            setValues(agrupado);
        }
        catch (error) {
            console.debug(error);
            debugger;
        }

        setLoading(false);
    }

    useEffect(() => {
        if (report !== 0) {
            getReportInfo();
        }
        else {
            dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "SlaReportSolicitation", value: report } });
        }
    }, [report])

    useEffect(() => {
        const interval = setInterval(() => {
            if (report) {
                getReportInfo();
            }
        }, 3600000);

        return () => clearInterval(interval);
    }, [report, values]);

    useEffect(() => {
        if (fieldReport.length > 0 && report !== 0) {
            setFieldReport(fieldReport.map(i => {
                return {
                    label: i.label,
                    text: i.text,
                    default: pref.dataLocal?.SlaReportSolicitation === i.field[0].value,
                    field: i.field
                }
            }))
        }
    }, [report])

    const groupByValuesList = (arrayValues: any[], data: any[]) => {
        let result = [...new Set(arrayValues.map(x => x.grupo))].map(x => {

            let item: any = {
                values: arrayValues.filter(y => y.grupo == x).map((u) => {
                    u.value = (u.value) ? u.value : 0;
                    const value = u.value.toString().includes('%')
                        ? u.value
                        : parseInt(u.value).toLocaleString('pt-BR');

                    return {
                        val: value,
                        color: u.fundo,
                        frente: u.frente
                    }
                }).filter(x => x != null),
                group: arrayValues.find(d => d.grupo == x).grupo,
            }

            if (report == 30070) {
                const columnsList = [...new Set(data.filter(y => y.titulo == x).map(x => x.tituloCard))].filter(x => x != null);
                item = { ...item, columns: columnsList };
            }

            return item;
        });

        return result;
    }

    const onChageSelectionReport = (selected: any) => {
        setReport(selected.field[0].value);
        dispatch({ type: "PREF_UPDATE_LOCAL", payload: { name: "SlaReportSolicitation", value: selected.field[0].value } });
    }

    const reportSelection = {
        selections: fieldReport,
        onChange: onChageSelectionReport
    }

    return (
        <Layout selection={reportSelection} >
            <LcLoading loading={loading} label={'Buscando relatório...'}>
                <div className="headerReport">
                    <h3>{principalTitle}</h3>
                </div>
                <div className='divTable'>
                    <table>
                        <>
                            {
                                !values[0]?.columns
                                    ? <>
                                        <thead className='topTitle'>
                                            <tr>
                                                <td />
                                                {
                                                    topTitle.map(text => {
                                                        return (
                                                            <td className='title'>
                                                                <p>{text}</p>
                                                            </td>

                                                        )
                                                    })
                                                }
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                values && values.map(val => {
                                                    return (
                                                        <tr>
                                                            <td className='leftTitle'> {val.group} </td>
                                                            {
                                                                val.values && val.values.map(v => {
                                                                    return (
                                                                        <td className='cardValue' style={{ backgroundColor: v.color, color: v.frente }}>
                                                                            <div className="card"> {v.val} </div>
                                                                        </td>
                                                                    )
                                                                })
                                                            }
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </>
                                    : <>
                                        {
                                            values && values.map(item => {
                                                return (
                                                    <>
                                                        <thead className='topTitle'>
                                                            <tr>
                                                                <td />
                                                                {
                                                                    item.columns && item.columns.map(text => {
                                                                        return (
                                                                            <td className='title'>
                                                                                <p>{text}</p>
                                                                            </td>

                                                                        )
                                                                    })
                                                                }
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            <tr>
                                                                <>
                                                                    {
                                                                        item.group &&
                                                                        <td className='leftTitle'> {item.group} </td>
                                                                    }
                                                                </>
                                                                {
                                                                    item.values && item.values.map(val => {
                                                                        return (
                                                                            <td className='cardValue' style={{ backgroundColor: val.color, color: val.frente }}>
                                                                                <div className="card"> {val.val} </div>
                                                                            </td>
                                                                        )
                                                                    })
                                                                }
                                                            </tr>
                                                        </tbody>
                                                    </>
                                                )
                                            })
                                        }
                                    </>
                            }
                        </>
                    </table>
                </div>
            </LcLoading>
        </Layout>
    );
}

export default SLAReport;